Controller.$inject = [];

function Controller() {
    let self = this;
}

export function HuiDialogHeader() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: Controller,
        bindToController: {
            onClose: '&',
            closeAutomationId: '@',
            hideClose: '<',
        },
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui-dialog-header">
                    <h5 class="modal-title" ng-transclude></h5>
                    <button type="button"
                            class="hui-close-btn"   
                            ng-class="{'d-none': $huiCtrl.hideClose}"
                            ng-click="$huiCtrl.onClose()"
                            ng-attr-automation="{{ $huiCtrl.closeAutomationId }}"
                            aria-label="{{ 'Close' | translate }}">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            `;
        }
    };
} 